// Public site facts shared by the footer and Pori. Update this source once.
export type SiteLink = {
  key: string; label: string; href: string; description: string;
  footerLabel: string; footerPrefix?: string;
};

export const SITE_CONTACTS: SiteLink[] = [
  { key: "developer", label: "개발교사 소개", footerPrefix: "개발교사", footerLabel: "박진환", href: "https://proximal-stranger-fa0.notion.site/1cb53a4832438028be97d7cb1b2ddb5f?pvs=4", description: "포에듀케이터를 만든 개발교사 박진환의 소개 페이지" },
  { key: "email", label: "개발자에게 이메일 보내기", footerPrefix: "Email", footerLabel: "hwanys2@naver.com", href: "mailto:hwanys2@naver.com", description: "개발자 문의 이메일 hwanys2@naver.com. 사이트 문의, 오류 신고, 기능 제안에 안내할 공개 연락처" },
  { key: "instagram", label: "인스타그램 @foreducator", footerPrefix: "인스타", footerLabel: "@foreducator", href: "https://www.instagram.com/foreducator/", description: "개발자의 포에듀케이터 인스타그램 계정 @foreducator" },
  { key: "openchat", label: "포에듀케이터 오픈채팅방", footerPrefix: "오픈채팅", footerLabel: "이용자 모임", href: "https://open.kakao.com/o/g3KNSC4e", description: "포에듀케이터 이용자 모임 카카오톡 오픈채팅방. 교과별 오픈채팅 목록 도구와는 다른 공식 이용자 모임" },
];

export const DEVELOPER_SITES: SiteLink[] = [
  { key: "pimath", label: "수학하는 즐거움 PiMath", footerLabel: "수학하는 즐거움 PiMath", href: "https://pimath.kr/", description: "개발자의 다른 사이트: 수학하는 즐거움 PiMath" },
  { key: "short", label: "한국어 단축주소 숏.한국", footerLabel: "한국어 단축주소 숏.한국", href: "https://숏.한국/", description: "개발자의 다른 사이트: 한국어 단축주소 숏.한국" },
  { key: "classpoint", label: "학급 상벌점 관리 ClassPoint", footerLabel: "학급 상벌점 관리 ClassPoint", href: "https://classpoint.kr/", description: "개발자의 다른 사이트: 학급 상벌점 관리 ClassPoint" },
  { key: "hiddeno", label: "우리 사이 작은 비밀 클럽 히든O", footerLabel: "우리 사이 작은 비밀 클럽 히든O", href: "https://hiddeno.com/", description: "개발자의 다른 사이트: 우리 사이 작은 비밀 클럽 히든O" },
];

export const SITE_INFO = {
  name: "Foreducator (포에듀케이터)",
  description: "교사를 위한 올인원 워크스페이스. 더 나은 교육 환경을 만들어갑니다.",
  developer: "박진환",
  contacts: SITE_CONTACTS,
  relatedSites: DEVELOPER_SITES,
};

export const SITE_LINKS = [...SITE_CONTACTS, ...DEVELOPER_SITES];

export function resolveSiteLinks(keys: unknown): SiteLink[] {
  if (!Array.isArray(keys)) return [];
  return [...new Set(keys)].flatMap((key) => {
    const link = SITE_LINKS.find((item) => item.key === key);
    return link ? [link] : [];
  }).slice(0, 4);
}

export function findSiteContactAnswer(query: string): { content: string; links: SiteLink[] } | undefined {
  const text = query.replace(/\s/g, "").toLowerCase();
  const email = SITE_CONTACTS.find((link) => link.key === "email")!;
  const instagram = SITE_CONTACTS.find((link) => link.key === "instagram")!;
  if (/인스타|instagram/.test(text)) return {
    content: `개발자의 포에듀케이터 인스타그램은 ${instagram.footerLabel}예요. 아래 버튼을 누르면 바로 열 수 있어요.`, links: resolveSiteLinks(["instagram"]),
  };
  if (/오픈채팅|오픈톡|단톡방|카톡방|카카오톡/.test(text) &&
    (/포에듀|foreducator|이용자|공식|개발자|이사이트/.test(text) || /^(오픈채팅|오픈톡|단톡방|카톡방|카카오톡)/.test(text))) return {
    content: "포에듀케이터 이용자 모임 오픈채팅방이 있어요. 아래 버튼으로 카카오톡 오픈채팅방에 들어갈 수 있어요.", links: resolveSiteLinks(["openchat"]),
  };
  if (/개발자|개발교사|제작자|운영자|연락처|문의처|기능제안|기능요청|버그신고|오류신고|누가만들/.test(text) ||
    /^(이메일|메일|연락|문의)/.test(text) || /포에듀케이터.*(연락|문의|메일)/.test(text)) return {
    content: `포에듀케이터를 만든 개발교사는 ${SITE_INFO.developer} 선생님이에요. 개발자에게는 ${email.footerLabel}으로 연락할 수 있어요. 인스타그램 ${instagram.footerLabel}와 포에듀케이터 이용자 모임 오픈채팅방도 아래에서 열 수 있어요.`,
    links: resolveSiteLinks(["email", "instagram", "openchat", "developer"]),
  };
  return undefined;
}
